export const MessageType = {
  CHILD_READY: 'CHILD_READY',
  INIT_PROPS: 'INIT_PROPS',
  UPDATE_PROPS: 'UPDATE_PROPS',
  INVOKE_FUNCTION: 'INVOKE_FUNCTION',
  FUNCTION_RESULT: 'FUNCTION_RESULT',
  FUNCTION_ERROR: 'FUNCTION_ERROR',
  RESIZE: 'RESIZE',
  DESTROY: 'DESTROY',
} as const

export type MessageTypeValue = (typeof MessageType)[keyof typeof MessageType]

export interface BridgeMessage {
  __afterpay_bridge__: true
  tag: string
  id: string
  type: MessageTypeValue
  payload?: unknown
  timestamp: number
}

export interface BridgeResponse extends BridgeMessage {
  correlationId: string
  error?: string
}

export interface FunctionRef {
  __bridge_fn__: true
  id: string
  name: string
}

export interface InvokeFunctionPayload {
  funcId: string
  callId: string
  args: unknown[]
}

export interface FunctionResultPayload {
  callId: string
  result: unknown
}

export interface FunctionErrorPayload {
  callId: string
  error: string
}

export interface ResizePayload {
  height?: number
  width?: number
}

export interface CreateBridgeOptions {
  tag: string
  container: string | HTMLElement
  url: string
  props: Record<string, unknown>
  iframe?: Record<string, string>
  onReady?: () => void
  timeout?: number
  debug?: boolean
}

export interface BridgeHandle {
  updateProps(newProps: Record<string, unknown>): void
  destroy(): void
}

export interface ConnectBridgeOptions {
  tag: string
  autoResize?: { height?: boolean; width?: boolean; element?: string }
  timeout?: number
  debug?: boolean
}

export interface ChildBridge {
  props: Record<string, unknown>
  onPropsUpdate(cb: (props: Record<string, unknown>) => void): void
}
